// extracted by mini-css-extract-plugin
export default {"container":"IV9Rhd4BORATyff5hC2T"};